import { computed } from 'vue'
import type { TableItems } from '@/types/component/common/table/commonTable'
import type { UploadTableRow } from '@/types/propertyTaxUpload/propertyTaxUpload'
import { usePropertyTaxUploadStore } from '@/stores/propertyTaxUploadStore'
import { storeToRefs } from 'pinia'
import { UploadStatusLabel } from '@/constants/ui/aeroUpload/uploadStatus'
import { format } from 'date-fns'

export const useUploadStatusTable = () => {
  const uploadStore = usePropertyTaxUploadStore()
  const { uploadFileList } = storeToRefs(uploadStore)

  /** アップロード状況テーブルのアイテム */
  const itemsTyped = computed<TableItems<Partial<UploadTableRow>>>(() =>
    uploadFileList.value.map(data => {
      const projectName = data.projectId
        ? (uploadStore.getProjectName(data.projectId) ?? '不明')
        : '（現在選択しているプロジェクト）'

      return {
        fileName: data.fileName,
        status: data.status,
        statusLabel:
          UploadStatusLabel?.[data.status]?.replace('{0}', data.progress.toFixed(0)) ?? '',
        completedDateTime: data.completedDateTime
          ? format(data.completedDateTime, 'yyyy-MM-dd HH:mm:ss')
          : '-',
        projectName
      }
    })
  )

  return { itemsTyped }
}
